











































import Moment from "moment";
import { Component, Mixins } from "vue-property-decorator";

@Component
export default class PointerEventsViewer extends Mixins() {
  shouldIgnoreTouchAction = true;
  shouldHandleMouseEvents = true;
  shouldHandlePointerEvents = true;
  logMax = 1000;
  logs: string[] = [];

  get logsAsString(): string {
    return this.logs.join("\r\n");
  }

  get pointerStyle() {
    return {
      touchAction: this.shouldIgnoreTouchAction ? "none" : "auto",
    };
  }

  handleMouseEvent(name: string, event: MouseEvent): void {
    if (this.shouldHandleMouseEvents) {
      this.log(name, this.toMouseEventString(event));
    }
  }

  private toMouseEventString(event: MouseEvent): string {
    return "(" + event.x + "," + event.y + ") (" + event.movementX + "," + event.movementY + ")";
  }

  handlePointerEvent(name: string, event: PointerEvent): void {
    if (this.shouldHandlePointerEvents) {
      this.log(name, this.toPointerEventString(event));
    }
  }

  private toPointerEventString(event: PointerEvent): string {
    return this.toMouseEventString(event) + " " + event.type + " " + event.width + "x" + event.height + " " + event.pressure + " " + event.tangentialPressure + " (" + event.tiltX + "," + event.tiltY + ")" + event.twist;
  }

  private log(name: string, message: string): void {
    const log = "[" + Moment().format("hh:mm:ss.SSS") + "]" + name + ": " + message;
    console.log(log);
    this.logs.unshift(log); // 先頭に追加.
    if (this.logMax < this.logs.length) {
      this.logs.pop();      // 末尾から削除.
    }
  }
}
